import { useEffect, useState } from 'react';
import { BRAND, fmt } from '@platform/shared';
import { Link } from '../lib/router';
import { useWsLatency, useWsStatus } from '../lib/ws';
import { useInstrument, useTicker } from '../stores/market';
import { STRIP_SYMBOLS } from './TickerStrip';
import { cx } from './ui';
import { InstrumentIcon } from './InstrumentIcon';

function Mini({ sym }: { sym: string }) {
  const t = useTicker(sym);
  const i = useInstrument(sym);
  return (
    <span className="num flex items-center gap-1.5 whitespace-nowrap">
      <InstrumentIcon symbol={sym} size={14} />
      <span className="text-muted">{sym}</span> {t ? fmt(t.mark, i?.priceDecimals ?? 2) : '—'}
    </span>
  );
}

function Clock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(t);
  }, []);
  return <span className="num text-muted">UTC {now.toISOString().slice(11, 19)}</span>;
}

export function FooterBar() {
  const status = useWsStatus();
  const latency = useWsLatency();
  const live = status === 'live';
  return (
    <footer className="flex flex-wrap items-center gap-x-5 gap-y-1 border-t border-line bg-panel px-4 py-1.5 text-[11.5px]">
      <span className={cx('flex items-center gap-1.5 rounded-full px-2 py-0.5 font-semibold', live ? 'bg-up-bg text-up' : 'bg-down-bg text-warn')} role="status">
        <span className={cx('size-[7px] rounded-full', live ? 'bg-up' : 'animate-pulse bg-warn')} />
        {live ? 'Live' : status === 'connecting' ? 'Connecting' : 'Reconnecting'}
      </span>
      {live && latency !== null && <span className="num text-muted">{latency} ms</span>}
      <span className="hidden h-3.5 w-px bg-line md:block" />
      <div className="hidden gap-5 md:flex">
        {STRIP_SYMBOLS.map((s) => (
          <Mini key={s} sym={s} />
        ))}
      </div>
      <div className="flex-1" />
      <Clock />
      <span className="hidden gap-3 sm:flex">
        <Link to="/terms" className="text-muted no-underline hover:text-fg">
          Terms
        </Link>
        <Link to="/privacy" className="text-muted no-underline hover:text-fg">
          Privacy
        </Link>
        <Link to="/risk-disclosure" className="text-muted no-underline hover:text-fg">
          Risk
        </Link>
      </span>
      <a href={BRAND.docsUrl} className="text-fg no-underline hover:underline">
        Docs
      </a>
    </footer>
  );
}
